import { CommonService } from "../../../../services/CommonService";
import { DOCOnlineService } from "../../../../services/DOCOnlineService";
import { InterviewService } from "../../../../services/InterviewService";

export function GenerateDocOnlineCtr(props) {
  return {
    getDocOnline() {
      return InterviewService.generateDocOnline(
        props.match.params.interviewId,
        props.match.params.docOnlineLanguageId
      ).then((data) => {
        return data;
      });
    },
    saveAs(docOnline) {
      return DOCOnlineService.SaveAsDocOnline(docOnline).then((data) => {
        return data;
      });
    },
    save(docOnline) {
      return DOCOnlineService.EditDocOnline(
        docOnline,
        props.match.params.interviewId,
        props.match.params.docOnlineLanguageId
      ).then((data) => {
        return data;
      });
    },
    generateUrl(languageId, companyId, docOnlineId) {
      return DOCOnlineService.generateUrl(
        docOnlineId,
        languageId,
        companyId
      ).then((data) => {
        return data;
      });
    },
    downloadDocOnline(
      templatePrefix,
      languageCode,
      downloadIsInPdf,
      fileName,
      docOnlineId
    ) {
      return DOCOnlineService.downloadDocOnline(
        docOnlineId,
        templatePrefix,
        languageCode,
        downloadIsInPdf,
        fileName
      ).then((data) => {
        return data;
      });
    },
    docOnlineService: DOCOnlineService,
    commonService: CommonService
  };
}
